import { EVENT5K } from "@/constants/testIds";

const REAL = [
  {
    url: "/images/volunteers-2025.png",
    label: "Community moved with purpose.",
  },
  {
    url: "/images/josiah-runner.jpg",
    label: "Youth showed up strong.",
  },
  {
    url: "/images/candid-runners.jpg",
    label: "Families showed up together.",
  },
  {
    url: "/images/youth-house-of-purpose.jpg",
    label: "Vendors connected with the next generation.",
  },
  {
    url: "/images/adult-runners.jpg",
    label: "Every step fueled a founder.",
  },
  {
    url: "/images/ebony-tonja.jpg",
    label: "Entrepreneurs were celebrated.",
  },
];

const STOCK = [];

export default function Gallery() {
  return (
    <section id="gallery" data-testid={EVENT5K.sectionGallery} className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#EC008C] font-bold mb-4">Community Highlights</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
              Highlights from <span className="text-[#00A651]">last year</span>.
            </h2>
            <p className="mt-3 font-display text-lg md:text-xl uppercase tracking-tight text-white/90 leading-tight">
              Families showed up. Entrepreneurs were celebrated.<br className="hidden md:block" />
              Vendors connected. <span className="text-[#EC008C]">Community moved with purpose.</span>
            </p>
          </div>
          <p className="text-[#A3A3A3] max-w-md">
            Real moments from our runners, walkers, families, vendors, and supporters. Your energy is the story.
          </p>
        </div>

        <div className="grid grid-cols-6 md:grid-cols-12 gap-3">
          <Tile item={REAL[0]} className="col-span-6 md:col-span-8 aspect-[16/10]" />
          <Tile item={REAL[1]} className="col-span-3 md:col-span-4 aspect-[4/5]" />
          <Tile item={REAL[2]} className="col-span-3 md:col-span-4 aspect-[4/5]" />
          <Tile item={REAL[3]} className="col-span-6 md:col-span-4 aspect-square" />
          <Tile item={REAL[4]} className="col-span-3 md:col-span-4 aspect-square" />
          <Tile item={REAL[5]} className="col-span-3 md:col-span-4 aspect-square" />
        </div>

        <div className="mt-6 text-xs text-[#71717A] uppercase tracking-widest">
          Real event photos from 2025 · more community shots to come
        </div>
      </div>
    </section>
  );
}

function Tile({ item, className }) {
  return (
    <div className={`relative overflow-hidden bg-[#141414] border border-[#27272A] group ${className}`}>
      <img
        src={item.url}
        alt={item.label}
        loading="lazy"
        className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
        <div className="font-display text-sm md:text-base font-bold uppercase leading-tight tracking-tight text-white">
          {item.label}
        </div>
      </div>
      <div className="absolute inset-0 ring-0 group-hover:ring-2 group-hover:ring-[#EC008C] transition" />
    </div>
  );
}
